import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import { SEARCH_FORM_REDUCERS } from 'state/reducers/search/searchReducers';
import { UserProfileContext } from 'auth/contexts/UserProfileContext';
import { SEARCH_TYPES } from 'state/services/searchApiUtils';
import AsyncContent from '../../components/AsyncContent';
import SelectTypeField from '../../components/SelectTypeField';
import FeedbackButton from './FeedbackButton';

export const SEARCH_TYPE_OPTIONS = [
  {
    value: SEARCH_TYPES.PATIENT,
    label: 'search.SearchForm.SearchType.Patients',
  },
  {
    value: SEARCH_TYPES.ORDERING_PHYSICIAN,
    label: 'search.SearchForm.SearchType.OrderingProviders',
  },
  // {
  //   value: SEARCH_TYPES.CONNECTIONS,
  //   label: 'Connections',
  // },
  // {
  //   value: SEARCH_TYPES.BILLING,
  //   label: 'Billing',
  // },
  // {
  //   value: SEARCH_TYPES.RECORDINGS,
  //   label: 'Recordings',
  // },
];

class PatientSearchForm extends React.PureComponent {
  render() {
    const {
      handleSubmit,
      isSubmitting,
      onSearchTypeChange,
      searchFieldComponent,
      children,
      styles,
      selectedSearchType,
    } = this.props;

    let selectedOptionValue = SEARCH_TYPE_OPTIONS[0].value;
    if (selectedSearchType) {
      selectedOptionValue = selectedSearchType;
    }

    return (
      <form onSubmit={handleSubmit}>
        <div className={styles.searchFields}>
          <div className={styles.searchType}>
            <Field
              component={SelectTypeField}
              name="searchType"
              className="searchTypeSelect react-select-filter-selector"
              selectedValue={selectedOptionValue}
              options={SEARCH_TYPE_OPTIONS}
              onSelect={onSearchTypeChange}
              isSearchable={false}
            />
          </div>
          {searchFieldComponent}
          <button
            className={styles.submitButton}
            type="submit"
            disabled={isSubmitting}
          >
            <AsyncContent isFetching={isSubmitting}>
              <FormattedMessage id="search.SearchForm.Button.Submit" />
            </AsyncContent>
          </button>
          {process.env.REACT_APP_ENABLE_FEEDBACK === '1' && (
            <FeedbackButton onClick={this.handleShowFeedback} />
          )}
        </div>
        <div className={styles.searchBarFilterBar}>
          <div className={styles.searchBarLabel}>
            <FormattedMessage id="search.SearchForm.RefineFilter.Label" />
          </div>
          <div className={styles.searchBarFilters}>{children}</div>
        </div>
      </form>
    );
  }
}

PatientSearchForm.contextType = UserProfileContext;
export default reduxForm({
  form: SEARCH_FORM_REDUCERS.PATIENT_SEARCH,
  onChange(values, dispatch, props, previousValues) {
    if (props.onFormChange) props.onFormChange(values, previousValues);
  },
})(PatientSearchForm);



// WEBPACK FOOTER //
// ./src/views/containers/Search/PatientSearchForm.jsx